// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.no-link[data-v-c7045e32] {\n  text-decoration: none !important;\n  color: inherit !important;\n}\n.v-footer--fixed[data-v-c7045e32] {\n  bottom: 62px !important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
